<vw-navbar />

<div class="wrapper-container-tlhex bg-body tlhex-view-case">
	<div class="container-fluid" style="height:100%; overflow-y:auto;">
		<div class="container-xl">

			<div class="row row-header">
				<div class="col-lg-12 align-items-center justify-content-between">
					<h1>{{ labels().VIEW_PAGE_COMPONENT_TITLE }}</h1>
				</div>
			</div>
			<div class="row row-contents">
				<div class="col-lg-12 position-relative">

					@let plan = srv.plan();
					@if (plan) {
					<vw-plan [plan]="plan" />
					}

					@let model = srv.model();
					@if (model) {

					@let imgs = srv.images();
					@if (!!imgs?.deformity) {
					<vw-deformity [model]="model" [img]="imgs?.deformity" />
					}
					@if (!!imgs?.templating) {
					<vw-correction [model]="model" [img]="imgs?.templating" />
					}

					}
				</div>
			</div>

		</div>
	</div>
</div>